export function createUploadProofLoader({ requestProof, storage, now = Date.now }) {
  const pending = new Map();
  const valid = proof => proof && typeof proof === 'object' && Number.isFinite(Number(proof.expire))
    && Number(proof.expire) * 1000 > now();
  return async query => {
    const key = `oss-cred-${query.fileType}`;
    let cached;
    try { cached = JSON.parse(storage.getItem(key)); }
    catch { storage.removeItem(key); }
    if (valid(cached)) return cached;
    if (pending.has(key)) return pending.get(key);
    const request = Promise.resolve().then(() => requestProof(query)).then(response => {
      if (!response?.success || !valid(response.data)) throw new Error('UPLOAD_PROOF_UNAVAILABLE');
      storage.setItem(key, JSON.stringify(response.data));
      return response.data;
    }).finally(() => { pending.delete(key); });
    pending.set(key, request);
    return request;
  };
}
